import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { Service } from 'src/app/services';
import { LoadingScreenService } from 'src/app/services/loading-screen/loading-screen.service';

@Component({
  selector: 'app-authentication-verification',
  templateUrl: './authentication-verification.component.html',
  styleUrls: ['./authentication-verification.component.sass']
})
export class AuthenticationVerificationComponent implements OnInit {

  public radio = [false, false];
  public subscriber: string;
  public email: string;
  public subscriberSend: string;
  public emailSend: string;
  public emailShow: string;
  public screen: string = 'sendCode';
  public option = [];
  @Input() subscriberSelected: string;
  @Output() validationScreen = new EventEmitter<any>();
  @Output() sw1 = new EventEmitter<any>();

  constructor(private services: Service, private loadingScreenService: LoadingScreenService, public global: GlobalService) {
  }

  ngOnInit(): void {
    this.loadOptions();
  }

  loadOptions() {
    this.loadingScreenService.startLoading();
    this.services.getValidationCodeOptions(sessionStorage.getItem("token"), this.subscriberSelected).subscribe(
      data => {
        this.loadingScreenService.stopLoading();
        if (data.hasError) {
          this.global.notif(data.errorDisplay);
        } else {
          if(data.email.length > 0) {
            let contAst = 0;
            while (data.email.charAt(contAst) != "@") {
              contAst++;
            }
            let emalEncripted = data.email.charAt(0);

            for (let index = 1; index < contAst - 2; index++) {
              emalEncripted = emalEncripted + "*";
            }
            for (let index = contAst - 1; index < data.email.length; index++) {
              emalEncripted = emalEncripted + data.email.charAt(index);
              this.emailShow = emalEncripted;
              this.email = data.email;
            }
          }
        }
        this.subscriber = data.mainSubscriber;
      }, error => {
        this.loadingScreenService.stopLoading();
      });
  }

  cancel() {
    this.sw1.next(true);
  }

  optionSendCode(option: number, method: string) {
    this.emailSend = '';
    this.subscriberSend = '';
    if (method == 'email') {
      this.radio[0] = true;
      this.radio[1] = false;
      this.emailSend = this.email;
      this.subscriberSend = "";
    } else if (method == 'movil') {
      this.radio[0] = false;
      this.radio[1] = true;
      this.emailSend = "";
      this.subscriberSend = this.subscriber;
    }
  }

  sendCode() {
    this.loadingScreenService.startLoading();
    this.services.getValidationCode(sessionStorage.getItem("token"), this.subscriberSend, this.emailSend).subscribe(data => {
      this.loadingScreenService.stopLoading();
      if (data.hasError == false) {
        this.global.notif(data.errorDisplay);
        this.validationScreen.emit('validCode');
      } else {
        this.global.notif(data.errorDisplay);
      }
    });
  }
}
